export default __webpack_public_path__ + "static/media/dot-red.c9b71af1.svg";